// import React, { useEffect, useRef } from "react";
// import "../css/HomeProducts.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
// import FlipBook from "./FlipBook";

// // Reusable ProductCard Component
// const ProductCard = ({ product }) => {
//   const productRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("fade-in");
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     if (productRef.current) observer.observe(productRef.current);

//     return () => {
//       if (productRef.current) observer.unobserve(productRef.current);
//     };
//   }, []);

//   return (
//     <div ref={productRef} className="product-card">
//       <div className="product-inner">
//         {/* Front Side */}
//         <div className="product-front">
//           <img
//             src={product.image}
//             alt={product.name}
//             className="product-image"
//           />
//           <h2 className="product-title">{product.name}</h2>
//         </div>

//         {/* Back Side */}
//         {product.description && (
//           <div className="product-back">
//             <p className="product-description">{product.description}</p>
//             <a href={product.learnMoreUrl} className="learn-more-btn">
//               Learn More <FontAwesomeIcon icon={faArrowRight} />
//             </a>

           
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // Reusable HomeProducts Component
// const HomeProducts = ({ products }) => {
//   return (
//     <div className="products-wrapper">
//       <h1 className="title">Our Products</h1>
//       <div className="grid-layout">
//         {products.map((product, index) => (
//           <ProductCard key={index} product={product} />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HomeProducts;



import React, { useEffect, useRef, useState } from "react";
import "../css/HomeProducts.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faDownload } from "@fortawesome/free-solid-svg-icons";
import FlipBook from "./FlipBook";

// Reusable ProductCard Component
const ProductCard = ({ product, openFlipBook }) => {
  const productRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          }
        });
      },
      { threshold: 0.2 }
    );

    if (productRef.current) observer.observe(productRef.current);

    return () => {
      if (productRef.current) observer.unobserve(productRef.current);
    };
  }, []);

  return (
    <div ref={productRef} className="product-card">
      <div className="product-inner">
        {/* Front Side */}
        <div className="product-front">
          <img src={product.image} alt={product.name} className="product-image" />
          <h2 className="product-title">{product.name}</h2>
        </div>

        {/* Back Side */}
        {product.description && (
          <div className="product-back">
            <p className="product-description">{product.description}</p>
            <a href={product.learnMoreUrl} className="learn-more-btn">
              Learn More <FontAwesomeIcon icon={faArrowRight} />
            </a>

            {/* Download Brochure Button */}
            {product.hasBrochure && (
              <button className="download-brochure-btn" onClick={openFlipBook}>
                <FontAwesomeIcon icon={faDownload} />  View Brochure
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// HomeProducts Component
const HomeProducts = ({ products }) => {
  
  const [isFlipBookOpen, setIsFlipBookOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null); // Track selected product

  const openFlipBook = (product) => {
    setSelectedProduct(product);
    setIsFlipBookOpen(true);
  };
  return (


<div className="products-wrapper">
      <h2 className="title">Our Products</h2>
      <div className="grid-layout">
        {products.map((product, index) => (
          <ProductCard key={index} product={product} openFlipBook={() => openFlipBook(product)} />
        ))}
      </div>

      {/* FlipBook Popup */}
      {isFlipBookOpen && selectedProduct?.brochure && (
        <FlipBook
          isOpen={isFlipBookOpen}
          setIsOpen={setIsFlipBookOpen}
          pages={selectedProduct.brochure.pages} // Array of image URLs
          brochureUrl={selectedProduct.brochure.url} // Downloadable brochure link
        />
      )}
    </div>
  );
};

export default HomeProducts;
